import { EventBus } from "../../utils/EventBus";

const securityVerifyEventBus = new EventBus();

export default securityVerifyEventBus;
